var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "txt-file",
    x: 0,
    y: 0,
    baseProfile: "tiny",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_925_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_323_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_337_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_342_",
    fill: "#FFF",
    d: "M422.3 477.9c0 7.6-6.2 13.8-13.8 13.8h-305c-7.6 0-13.8-6.2-13.8-13.8V34.1c0-7.6 6.2-13.8 13.8-13.8h230.1V109h88.7v368.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_339_",
    fill: "#2B669F",
    d: "M333.6 6H103.5C88 6 75.4 18.6 75.4 34.1v443.8c0 15.5 12.6 28.1 28.1 28.1h305c15.5 0 28.1-12.6 28.1-28.1V109.1L333.6 6zm88.7 471.9c0 7.6-6.2 13.8-13.8 13.8h-305c-7.6 0-13.8-6.2-13.8-13.8V34.1c0-7.6 6.2-13.8 13.8-13.8h230.1V109h88.7v368.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_338_",
    fill: "#084272",
    d: "M333.6 6v103.1h103z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_332_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_336_",
    fill: "#084272",
    d: "M465.9 450.8H46.1V308c0-9.8 7.9-17.7 17.7-17.7h384.3c9.8 0 17.7 7.9 17.7 17.7v142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_335_",
    fill: "#1A252D",
    d: "M436.6 450.8v19.5l29.3-19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_334_",
    fill: "#1A252D",
    d: "M75.4 450.8v19.5l-29.3-19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_333_",
    fill: "#2B669F",
    d: "M64.1 308.4h383.7v124.5H64.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_324_",
    fill: "#2B669F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_331_",
    d: "M298.3 78.6h-177a6.7 6.7 0 0 1 0-13.4h177a6.7 6.7 0 0 1 0 13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_330_",
    d: "M298.3 110.6h-177a6.7 6.7 0 0 1 0-13.4h177a6.7 6.7 0 0 1 0 13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_329_",
    d: "M391.8 142.5H121.3a6.7 6.7 0 0 1 0-13.4h270.5a6.7 6.7 0 0 1 0 13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_328_",
    d: "M391.8 174.5H121.3a6.7 6.7 0 0 1 0-13.4h270.5a6.7 6.7 0 0 1 0 13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_327_",
    d: "M391.8 206.5H121.3a6.7 6.7 0 0 1 0-13.4h270.5a6.7 6.7 0 0 1 0 13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_326_",
    d: "M391.8 238.4H121.3a6.7 6.7 0 0 1 0-13.4h270.5a6.7 6.7 0 0 1 0 13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_325_",
    d: "M391.8 270.4H121.3a6.7 6.7 0 0 1 0-13.4h270.5a6.7 6.7 0 0 1 0 13.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_814_",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_764_",
    d: "M207.8 333.1v14.7h9.3v12.8h-9.3v27.1c0 2.1.4 3.6 1.3 4.6.9.9 2 1.4 3.5 1.4.9 0 1.7 0 2.3-.1.6-.1 1.3-.2 2.2-.4l1.3 13.7c-1.9.5-3.5.8-5 1-1.5.2-3.3.3-5.3.3-6.1 0-10.7-1.6-13.9-4.9-3.2-3.2-4.7-8.4-4.7-15.4v-27.2H181v-12.8h8.3v-14.7h18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_766_",
    d: "M257.3 365.2h.3l7.5-17.4h20.7L268.7 377l17.8 29.9h-20.7l-7.9-18h-.3l-7.9 18H229l17.8-29.9-17.2-29.2h20.6l7.1 17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_768_",
    d: "M320.5 333.1v14.7h9.3v12.8h-9.3v27.1c0 2.1.4 3.6 1.3 4.6.9.9 2 1.4 3.5 1.4.9 0 1.7 0 2.3-.1.6-.1 1.3-.2 2.2-.4l1.3 13.7c-1.9.5-3.5.8-5 1-1.5.2-3.3.3-5.3.3-6.1 0-10.7-1.6-13.9-4.9-3.2-3.2-4.7-8.4-4.7-15.4v-27.2h-8.3v-12.8h8.3v-14.7h18.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFileIcon);
export default __webpack_public_path__ + "static/media/textFileIcon.9ccb9e96223cfb0ad3453be925e2f20d.svg";
export { ForwardRef as ReactComponent };